import EntryList from "../component/EntryList";
import IntroBlock from "../component/IntroBlock";

const MainPage: React.FC = () => {
    return (
        <>
            <IntroBlock/>
            <EntryList/>
        </>
    );
};
export default MainPage;